import ReactMarkdown from 'react-markdown'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import remarkGfm from 'remark-gfm'
import remarkBreaks from 'remark-breaks'
import { ChartRenderer } from './ChartRenderer'

export function MathText({ text, className = '' }: { text: string; className?: string }) {
  // Pre-process text to handle typical KaTeX delimiters like \( \) or \[ \] by converting them to $ or $$
  // because remark-math prefers $ and $$
  const processedText = text
    .replace(/\\\((.*?)\\\)/g, '$$$1$$') // \( ... \) -> $...$
    .replace(/\\\[(.*?)\\\]/g, '$$$$$1$$$$') // \[ ... \] -> $$...$$
    .replace(/\$([^\$]+)\$/g, (match, p1) => `$${p1.trim()}$`) // fix Typst spaced math $ x $ -> $x$
    .replace(/vect\(([^)]+)\)/g, '\\overrightarrow{$1}') // Fix Typst vect(u) -> \overrightarrow{u}

  return (
    <div className={`markdown-body ${className}`} style={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}>
      <ReactMarkdown
        remarkPlugins={[remarkMath, remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeKatex]}
        components={{
          // Unwrap <p> if it's the only child to avoid breaking flex/inline layouts
          // But actually, letting it be block is usually fine. We'll just style p to have no bottom margin if it's last.
          p: ({ node, ...props }) => <p style={{ margin: 0, padding: 0 }} {...props} />,
          code: ({ node, inline, className, children, ...props }: any) => {
            const match = /language-(\w+)/.exec(className || '')
            if (!inline && match && match[1] === 'chart') {
              return <ChartRenderer code={String(children).replace(/\n$/, '')} />
            }
            return <code className={className} {...props}>{children}</code>
          }
        }}
      >
        {processedText}
      </ReactMarkdown>
    </div>
  )
}
